/** ENDS importer accepts relative values but the UI has no in-app page to point them at. */
export const isAbsoluteHttpUrl = (value: string): boolean => /^https?:\/\//i.test(value.trim());

export const formatCount = (value: number | null | undefined): string =>
  value == null ? '—' : value.toLocaleString();
